import { API_BASE_URL } from "../urls.api";

export const BLACKLIST_PHONES_URL = `${API_BASE_URL}/blacklist-phones`;

export const getBlacklistPhoneByRoomUrl = (roomId: string) =>
  `${BLACKLIST_PHONES_URL}/room/${roomId}`;

export const deleteBlacklistPhoneUrl = (phone: string, roomId: string) =>
  `${BLACKLIST_PHONES_URL}/${encodeURIComponent(phone)}/${roomId}`;
